import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { Loading, LoadingWrapper } from './view';

export const ApplicationLoader: React.FC = () => {
    const { t } = useTranslation();

    return (
        <LoadingWrapper>
            <Loading icon="icSpinner32" colorVariant="basic" size={32} />
            <Typography variant="title9" colorVariant="base">
                {t('web_call_loading')}
            </Typography>
        </LoadingWrapper>
    );
};
